export default "__VITE_ASSET__B1uF_yqf__"